import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Stars           from './components/Stars';
import OrganizerFlow  from './components/OrganizerFlow';
import ShareScreen    from './components/ShareScreen';
import ParticipantFlow from './components/ParticipantFlow';
import Footer         from './components/Footer';
import './index.css';

function NotFound() {
  const navigate = useNavigate();
  return (
    <main id="main-content" style={{
      textAlign: 'center', padding: '80px 32px',
      position: 'relative', zIndex: 1, maxWidth: 600, margin: '0 auto',
    }}>
      <div style={{ fontSize: 56, marginBottom: 24 }} aria-hidden="true">🌌</div>
      <h1 style={{ fontSize: '1.6rem', marginBottom: 16 }}>Page not found</h1>
      <p style={{ color: 'var(--muted)', fontSize: 17, lineHeight: 1.8, fontStyle: 'italic' }}>
        You have reached the Great Barrier at the edge of the galaxy where there are no meetings.
        May you bring with you some of the peace from out here back with you on your journey home.
      </p>
      <button className="btn-ghost" style={{ marginTop: 36 }} onClick={() => navigate('/')}>
        ← Return home
      </button>
      <Footer />
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <a href="#main-content" className="skip-to-main">Skip to main content</a>
        <Stars count={60} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <Routes>
            <Route path="/"              element={<OrganizerFlow />} />
            <Route path="/share/:pollId" element={<ShareScreen />} />
            <Route path="/poll/:pollId"  element={<ParticipantFlow />} />
            <Route path="*"             element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
